import request from "@/utils/request";

//加入购物车
export function addCart(data) {
  return request({
    url: "/api/mts-api/shopping/cart/item/add",
    method: "post",
    data: data,
  });
}

//获取购物车列表
export function getCartList(params) {
  return request({
    url: "/api/mts-api/shopping/cart/item/list",
    method: "get",
    params: params,
  });
}

//更新购物车数量
export function updateBatch(data) {
  return request({
    url: "/api/mts-api/shopping/cart/item/batchUpdate",
    method: "post",
    data: data,
  });
}

//创建购物车订单
export function createCartOrder(data) {
  return request({
    url: "/api/mts-api/shopping/cart/item/createPreOrder",
    method: "post",
    data: data,
  });
}

//删除购物车商品
export function deleteCart(data) {
  return request({
    url: "/api/mts-api/shopping/cart/item/delete/" + data.ids,
    method: "post",
    data: data,
  });
}
